module.exports = __webpack_public_path__ + "img/btimes.6a0e437f.png";